import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { MessageService } from "../../core/message.service";
// import { MessagesConstants } from "src/app/core/messages.constants";
import { BlockUI, NgBlockUI } from "ng-block-ui";
// import { MessageBox, MessageBoxButton } from "../../core/message-box";
import { MatDialog } from "@angular/material/dialog";
import { ArquivoDocumento } from "src/app/model/arquivo-documento";
import { MessageBox, MessageBoxButton } from "src/app/core/message-box";
// import { ArquivoDocumento } from "src/app/model/arquivo-documento";
// import { DocumentoService } from "src/app/service/documento/documento-service";

@Component({
  selector: "app-doc-upload",
  templateUrl: "./doc-upload.component.html",
  styleUrls: ["./doc-upload.component.css"],
  // providers: [DocumentoService],
})
export class DocUploadComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  @Input("tituloDoc")
  tituloDoc: string;

  @Input("tipoDoc")
  tipoDocumento: string;

  @Input("tipoDocEnum")
  tipoDocEnum: any;

  @Input("tooltip")
  tooltip: string;

  @Input("desabilitado")
  desabilitado: boolean = false;

  @Input("modoVisualizacao")
  modoVisualizacao: boolean = false;

  @Input("tamanhoMaximoArquivo")
  tamanhoMaximoArquivo: number = 20971520;

  @Input("maxQuantidadeArquivos")
  maxQuantidadeArquivos: number = -1;

  @Output()
  removeEvent: EventEmitter<ArquivoDocumento> = new EventEmitter();

  fileReader: FileReader;
  fileToUpload: File = null;
  listaDocumentos: ArquivoDocumento[];

  @ViewChild("documentInput")
  myAttachmentFile: ElementRef;

  constructor(
    private message: MessageService,
    private dialog: MatDialog,
    // private documentoService: DocumentoService
  ) {}

  ngOnInit() {      
    this.listaDocumentos = new Array<ArquivoDocumento>();
  }

  handleFileInput(event) {
    if (
      this.maxQuantidadeArquivos > 0 
      // &&
      // this.listaDocumentos.length >= this.maxQuantidadeArquivos
    ) {
      this.message.sendMessage(
        "Sistema de Medida Protetiva",
        "Permitido anexar no máximo " +
          this.maxQuantidadeArquivos +
          " arquivo(s)."
      );
      return;
    }

    if (event.target.files && event.target.files[0]) {
      this.fileToUpload = event.target.files[0];

      if (
        this.fileToUpload.type !== "application/pdf" &&
        !this.fileToUpload.type.includes("image")
      ) {
        this.message.sendMessage(
          "Sistema de Medida Protetiva",
          "É permitido anexar somente arquivos do tipo PDF e arquivos de Imagem."
        );
        return;
      } else {
        if (this.fileToUpload.size === 0) {
          this.message.sendMessage(
            "Sistema de Medida Protetiva",
            "Arquivo vazio não pode ser anexado."
          );
          this.limparCampoFileInput();
        } else if (this.fileToUpload.size > this.tamanhoMaximoArquivo) {
          this.message.sendMessage(
            "Sistema de Medida Protetiva",
            "Não é permitido upload de arquivos com tamanho superior a " +
              this.formatBytes(this.tamanhoMaximoArquivo)
          );
          this.limparCampoFileInput();
        }
      }

      this.upload(event.target.files[0]);
    }
  }

  public formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }


  limparCampoFileInput() {
    this.fileToUpload = null;
    this.myAttachmentFile.nativeElement.value = "";
  }

  upload(file: File) {
    const documentoAnexo = new ArquivoDocumento();

    this.fileReader = new FileReader();
    this.fileReader.readAsDataURL(file);
    documentoAnexo.nome = file.name.substr(0, file.name.lastIndexOf("."));
    const extensao = file.name.substr(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    documentoAnexo.extensao = extensao.toLocaleLowerCase();
    documentoAnexo.arquivo = file;

    documentoAnexo.tipo = this.tipoDocumento;

    this.listaDocumentos.push(documentoAnexo);
    this.myAttachmentFile.nativeElement.value = "";
  }

  public carregaArquivo(doc: ArquivoDocumento) {
    if (doc.arquivo) {
      this.downloadFile(doc.arquivo, doc.nome + "." + doc.extensao);
    } else {
      this.blockUI.start("Carregando...");
    }
  }

  private downloadFile(file: any, fileName: string) {
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement("a");
    link.href = fileURL;
    link.download = fileName;
    link.click();
    setTimeout(function () {
      URL.revokeObjectURL(fileURL);
      link.remove();
    }, 1000);
  }

  addDoc(documento: ArquivoDocumento) {
    this.listaDocumentos.push(documento);
  }

  getTipoDocumento(event) {
    this.tipoDocumento = event.value;
  }

  removerItem(anexo: ArquivoDocumento) {
    MessageBox.show(
      this.dialog,
      "Confirma exclusão do arquivo?",
      "Confirmação",
      null,
      MessageBoxButton.OkCancel,
      false,
      null,
      "600px"
    ).subscribe((result) => {
      if (result === true) {       
        this.listaDocumentos = this.listaDocumentos.filter(
          (item) => item !== anexo
        );        
      }
    });
  }
}
